export function HelpPage() {
  return (
    <section className="help-page">
      <p className="eyebrow">Help</p>
      <h1>How to use the calling portal</h1>

      <p className="help-introduction">
        This portal helps staff book shared phones for
        calling future students, participants and contacts.
      </p>

      <div className="help-content">
        <article className="help-block">
          <h2>Overview</h2>
          <ol>
            <li>Log in to this portal</li>
            <li><strong>Book a phone</strong></li>
            <li>Log in to <strong>Phonero</strong></li>
            <li>Log in on <strong>HubSpot</strong></li>
            <li>Call</li>
          </ol>
        </article>
      </div>

      <div className="help-content">
        <article className="help-block">
          <h2>Book a phone before calling</h2>

          <p>
            You need an active phone booking before signing in
            to the Phonero portal. The booking gives you a phone
            number, username, password and phone email.
          </p>

          <p>
            You need to log in to <strong>Phonero</strong> before you
            start calling.
          </p>

          <ol>
            <li>Select <strong>Book a phone</strong>.</li>
            <li>Choose what you are calling for - DTS, The Send, etc.</li>
            <li>
              Open <strong>My booking</strong> to view your
              Phonero login information. (It is also shown
              on the main page).
            </li>
            <li>Use the login info to log in to <strong>Phonero</strong>.
                (Follow the link on the <strong>My booking</strong> page.
            </li>
          </ol>
        </article>
      </div>

      <div className="help-content">
        <article className="help-block">
          <h2>Inviting external users</h2>
        
          <p>
            Everyone can call.<br/>
            Any YWAM user can just log right in to the portal and
            will automatically receive the <strong>Caller</strong> role.
          </p>
          <p>
            If want to invite callers that do not have a YWAM user,
            you need to create an <strong>Event</strong> (only <strong>Event Managers</strong> can
            do this).
          </p>
          <p>
            <ol>
              <li>Create an <strong>Event</strong></li>
              <li>Reserve numbers</li>
              <li>Invite users (internal or external)</li>
            </ol>
          </p>
        </article>
      </div>

      <div className="help-content">
        <article className="help-block">
          <h2>Creating an Event</h2>
        
          <p>
            For special <strong>Events</strong>, you can reserve
            phones for your event.<br/>
            Only <strong>Event Managers</strong> can create <strong>Events</strong>.
          </p>
          <p>
            An event is any call event that needs a number of phones
            for a periode of time. You reserve an amount of numbers
            for a specific date range. Only members of your event
            can book these phones.
          </p>
          <p>
            <ol>
                <li>Create the <strong>Event</strong></li>
                <li>Select outgoing number</li>
                <li>Reserve phone numbers</li>
                <li>Invite callers - internal staff or external users</li>
            </ol>
          </p>
          <p>
            External users will receive an SMS to log in to the system.
          </p>
        </article>
      </div>


    </section>
  );
}